import {styled, px} from '../../../utils';
import {padding} from 'polished';
import {Header} from '../../Layout';

export default styled(Header)(
  ({
    theme: {
      globalHeader: {
        backgroundColor,
        height,
        paddingX,
        enableShadow,
        shadowOffsetY,
        shadowBlurRadius,
        shadowColor,
        zIndex
      },
      globalSider: {width: siderWidth}
    }
  }) => ({
    position: 'fixed',
    top: 0,
    right: 0,
    width: `calc(100% - ${px(siderWidth)})`,
    height: height,
    lineHeight: px(height),
    ...padding(0, paddingX),
    backgroundColor,
    zIndex,
    ...(enableShadow
      ? {
          boxShadow: `0 ${px(shadowOffsetY)} ${px(shadowBlurRadius)} ${shadowColor}`
        }
      : {})
  })
);



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Header/Header.tsx